import Tr from "translations/Translations";

export default {
    number: {
        id: 'number',
        label: Tr('purchase_group_number')
    },
    organization: {
        id: 'organization',
        label: Tr('organizational_unit'),
        transform: (org) => org ? org.name : ""
    },
    name: {
        id: 'name',
        label: Tr('purchase_group_name')
    },
    description: {
        id: 'description',
        label: Tr('purchase_group_description')
    }
}